import axios from 'axios';

// Post metoda pro volani loginu, ktera nam vraci token jako string
const nastavitUcetApi = async (id: number) => {
    await axios({
        method: 'POST',
        url: `Portal/NastavitUcet/${id}`
    });
};

export default nastavitUcetApi;
